module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAAG1BMVEUAM5n///8fTKUIOZwyW60uWKtDabR/mcxvjMZ+iV0vAAAAl0lEQVQY04XRIQ7CUBBF0TtA0HMTGpAoNAkbKEuowhJ2gMCzdETb318agjxiMjPvoaqPy0lVUW0CyG70jgCS62AG0zshkkgIRektoJiVQ2yJ4o0IDg540hDFSUcS6uggsVhd+FibFefJwHrh48wr7rP57d99TXWfyr66X8WWuXP6X8XDlI+Kvr98KPn+6MNXAHkr/VV9fgAVPRVLOQd+9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diving/cif.png
// module id = q8Xl
// module chunks = 1